<template>
  <div class="smart-recap"> <!-- mobile version -->
    <p class="smart-recap__title">Completa la prenotazione!</p>
    <div class="smart-recap__wrap">
      <div class="smart-recap__text">
        <span>€ {{ price }}</span>
        <span>include gestione e assistenza</span>
      </div>
      <vb-icon class="smart-recap__icon" :name="'angle_small_right'" :color="'fff'" :size="32" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'smart-recap',

  components: {
  },

  props: {
    price: String,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .smart-recap {
    background-color: var(--primary);
    color: $white;
    text-align: center;
    padding: 10px;
    border-radius: 10px;
    margin-bottom: 15px;
    position: relative;

    &__title {
      font-weight: $vb-font-weight-semibold;
      font-size: $font-size-lg;
      margin-bottom: 5px;
    }

    span {
      display: block;

      &:first-child {
        color: var(--secondary);
        font-weight: $vb-font-weight-semibold;
        font-size: $font-size-xl;
      }

      &:last-child {
        font-size: $font-size-sm;
        opacity: .5;
      }
    }

    &__icon {
      width: 32px;
      height: 32px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 10px;
      margin: auto;
    }
  }

</style>